const MenuBuilderConfig = {
  itemGalleryLimit: 5,
};

export default MenuBuilderConfig;
